/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/speedometer'
export default icon
